module.exports = __webpack_public_path__ + "img/logo.398e0090.png";